function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#3FC0C4",
  strokeWidth: 2,
  d: "M12.825 3.15h14.923l10.727 10.894V35.55a6.3 6.3 0 0 1-6.3 6.3h-19.35a6.3 6.3 0 0 1-6.3-6.3V9.45a6.3 6.3 0 0 1 6.3-6.3z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M38.25 14.344h-4.393c-3.066 0-5.552-2.382-5.552-5.32V4.5m-8.622 15.536c-.894-.634-2.13.006-2.13 1.101v11.87c0 1.096 1.236 1.735 2.13 1.102l8.382-5.935a1.35 1.35 0 0 0 0-2.203l-8.382-5.935z"
});

var SvgVideoMarine = function SvgVideoMarine(props) {
  return React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjgyNSAzLjE1SDI3Ljc0ODFMMzguNDc1IDE0LjA0NDRWMzUuNTVDMzguNDc1IDM5LjAyOTQgMzUuNjU0NCA0MS44NSAzMi4xNzUgNDEuODVIMTIuODI1QzkuMzQ1NjEgNDEuODUgNi41MjUgMzkuMDI5NCA2LjUyNSAzNS41NVY5LjQ1QzYuNTI1IDUuOTcwNjEgOS4zNDU2MSAzLjE1IDEyLjgyNSAzLjE1WiIgc3Ryb2tlPSIjM0ZDMEM0IiBzdHJva2Utd2lkdGg9IjEuOCIvPgo8cGF0aCBkPSJNMzguMjQ5NSAxNC4zNDQxSDMzLjg1NjlDMzAuNzkwNSAxNC4zNDQxIDI4LjMwNDcgMTEuOTYxOCAyOC4zMDQ3IDkuMDIzMjFWNC41IiBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5LjY4MjggMjAuMDM1NkMxOC43ODg4IDE5LjQwMjUgMTcuNTUyNyAyMC4wNDE4IDE3LjU1MjcgMjEuMTM3M1YzMy4wMDczQzE3LjU1MjcgMzQuMTAyOCAxOC43ODg4IDM0Ljc0MjEgMTkuNjgyOCAzNC4xMDkxTDI4LjA2NSAyOC4xNzQxQzI4LjgyNDkgMjcuNjM2MSAyOC44MjQ5IDI2LjUwODUgMjguMDY1IDI1Ljk3MDVMMTkuNjgyOCAyMC4wMzU2WiIgc3Ryb2tlPSIjM0ZDMEM0IiBzdHJva2Utd2lkdGg9IjEuOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgVideoMarine as ReactComponent };